import React, { Component } from 'react';
import { Button, Icon, Label, Table, Sidebar, Header, Form, Segment, Dimmer, Loader }
        from 'semantic-ui-react';
import { map } from 'lodash';
import {observer} from 'mobx-react';
import store from '../store/dochist-store';
import { withRouter } from 'react-router-dom'
import ReactTable from "react-table";
import * as mobx from 'mobx';


class DocHistDetail extends Component {

  constructor(props) {
  	super(props);
  	this.state = {
  		visible: false
  	}
  }

  componentDidMount() {
    const { match } = this.props;
    store.getBCDocHist(match.params.id);

  }	

renderReactTable() {
    const histdocs = mobx.toJS(store.histDetailDocs);

    return(
        <ReactTable
          data={histdocs}
          noDataText="No records found"
          columns = {[
            { Header: "BlockChain Trxn Id", accessor: "TxId", width: 200 },
            { Header: "File Name", accessor: "value.File_Name" },
            { Header: "File Version", accessor: "value.Version" },
            { Header: "Created By", accessor: "value.Created_By_Id" },
            { Header: "Creation Date", accessor: "value.Creation_Date" },
            { Header: "Status", accessor: "value.Approve_Status" },
            { Header: "Approved By", accessor: "value.Approver_ID"},
          ]}
          style={{
            height: '80vh'
          }}
          defaultPageSize={10}
          //className="-striped -highlight"
          showPaginationTop={true}
          showPaginationBottom={false}   
        />

    )

  }


  render() {
        const { visible, value } = this.state
         const { match } = this.props;
        const docid= match.params.id

    return (
      <React.Fragment>
        <div>
                  <h4 align="left">Document Version History</h4>
        </div>
        {store.loading && (
					<Segment>
						<Dimmer active inverted>
							<Loader inverted>Loading</Loader>
						</Dimmer>
					</Segment>
				)}

        {!store.loading && this.renderReactTable()}

      </React.Fragment>
    );
  }
}

export default withRouter(observer(DocHistDetail));

//{ Header: "BlockChain Trxn Date",accessor: "timestamp"},







// WEBPACK FOOTER //
// ./src/containers/DocHistDetail.js